import React, { type ReactNode } from 'react';
import { P, Strong } from '@mentimeter/ragnar-ui/typography';
import { useTranslations } from 'next-intl';

const StrongText = (children: ReactNode) => Strong({ children });

export const JoinTeamConsentFreeUserContent = () => {
  const t = useTranslations('onboarding.join_workspace');
  return (
    <P mt={3} mb={2}>
      {t.rich('join_team_consent_free_user_message', {
        strong: StrongText,
      })}
    </P>
  );
};
